export default {
    WarrantyLookupEvent: 'WarrantyLookupEvent',
    WarrantyUpdateEvent: 'WarrantyUpdateEvent',
    OrderCreationEvent: 'OrderCreationEvent',
};